module.exports = __webpack_public_path__ + "assets/ilustrasi-create-microsite.de56831c.svg";